import { APP_I18N, IS_DEBUG } from '@/client/confs/app';
import i18next from 'i18next';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18next
  .use(backend)
  .use(initReactI18next)
  .init({
    // https://www.i18next.com/overview/configuration-options
    debug: IS_DEBUG,
    lng: APP_I18N.defaultLocale,
    fallbackLng: APP_I18N.defaultLocale,
    supportedLngs: APP_I18N.locales.map(item => item.lang),
    lowerCaseLng: true,
    load: 'currentOnly',
    defaultNS: 'translation',
    fallbackNS: 'translation',
    interpolation: { escapeValue: false },
    // Never suspend the page while /lang/*.json loads; components pass fallback
    // defaults like t('key', 'Default'), so text renders immediately.
    // 'loaded' makes components re-render when a namespace JSON arrives after
    // first paint (cold cache after an APP_I18N.version bump) — without it the
    // default fallback text sticks until the next navigation.
    react: { useSuspense: false, bindI18n: 'languageChanged loaded' },
    // https://github.com/i18next/i18next-http-backend
    backend: { loadPath: '/lang/{{lng}}/{{ns}}.json', queryStringParams: { v: APP_I18N.version } },
  });

export default i18next;
